import { createAction, props } from '@ngrx/store'
import { Update } from '@ngrx/entity'
import { CreateChargePayload, ChargeResponse, UpdateChargePayload } from './model'

export const LoadCharges = createAction('[Charge] Load Charges')
export const LoadChargesComplete = createAction(
  '[Charge] Load Charges Complete',
  props<{ charges: ChargeResponse[] }>()
)

export const LoadChargesByIds = createAction('[Charge] Load Charges By Ids', props<{ ids: string[] }>())
export const LoadChargesByIdsComplete = createAction(
  '[Charge] Load Charges By Ids Complete',
  props<{ charges: ChargeResponse[] }>()
)

export const AddCharge = createAction('[Charge] Add Charge', props<{ payload: CreateChargePayload }>())
export const AddChargeComplete = createAction('[Charge] Add Charge Complete', props<{ charge: ChargeResponse }>())

export const UpdateCharge = createAction(
  '[Charge] Update Charge',
  props<{ payload: UpdateChargePayload; chargeId: string }>()
)
export const UpdateChargeComplete = createAction(
  '[Charge] Update Charge Complete',
  props<{ update: Update<ChargeResponse> }>()
)

export const DeleteCharge = createAction('[Charge] Delete Charge', props<{ id: string }>())
export const DeleteChargeComplete = createAction('[Charge] Delete Charge Complete', props<{ id: string }>())

export const DeleteCharges = createAction('[Charge] Delete Charges', props<{ ids: string[] }>())
export const DeleteChargesComplete = createAction('[Charge] Delete Charges Complete', props<{ ids: string[] }>())
